import type { Action, Reducer } from './collections.types';

/**
 * Enhanced reducer type that receives the full root state as a third parameter
 */
type EnhancedReducer<S = any, RS = any> = (
  state: S | undefined,
  action: Action,
  rootState: RS
) => S;

/**
 * Reducer enhancer that injects full state to reducer
 *
 * @param reducer - Reducer to enhance with full state access
 * @param field - Field on root state assigned to this reducer
 * @returns Enhanced reducer that has access to full root state
 */
export default function allstate<S, RS extends Record<string, any>>(
  reducer: EnhancedReducer<S, RS>,
  field: keyof RS
): Reducer<RS> {
  return (state: RS = {} as RS, action: Action): RS => {
    const fieldState = state[field] as S;
    const reduced = reducer(fieldState, action, state);

    return reduced !== fieldState ? { ...state, [field]: reduced } : state;
  };
}
